import { defineComponent as _defineComponent } from 'vue'
import { NameType } from '@/views/Automation/CampaignCreatorV2/ab/core/helpers';
import { MacroOptions } from '@/views/Automation/CampaignCreatorV2/ab/core/IABTest';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcDropdown, {
  DropdownOption,
} from '@/views/Automation/CampaignCreatorV2/components/CcDropdown/CcDropdown.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import uid from 'uid';
import { computed, ref } from 'vue';
import { ErrorData } from '../../store/AbVariables';
import { ErrorType } from '../../store/Types';
import { MacroType } from '../../validation/ValidationTypes';

type NameMacro = { id: string; value: string; name: string; type: string; macro: string; valueType: string };
type Props = { value?: NameType; macros: MacroOptions[]; title?: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'CcCreateTemplateModal.ts',
  props: {
    value: null,
    macros: null,
    title: { default: 'Campaign Name' }
  },
  emits: ["onSave"],
  setup(__props: any, { expose, emit: emits }: { emit: ((e: 'onSave', value: Omit<NameType, 'name'>) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: NameType, macros: MacroOptions[], title: string };





const macroError: ErrorData<any, any, any>[] = [
  {
    message: 'Macro can not be empty',
    field: '',
    entity: '',
    type: ErrorType.BLOCKING,
  },
];

const fieldSeparatorError: ErrorData<any, any, any>[] = [
  {
    message: 'Field Separator is not allowed to be empty',
    field: '',
    entity: '',
    type: ErrorType.BLOCKING,
  },
];

const itemSeparatorError: ErrorData<any, any, any>[] = [
  {
    message: 'Item Separator is not allowed to be empty',
    field: '',
    entity: '',
    type: ErrorType.BLOCKING,
  },
];

// const macros = computed(() => campaignGetters.getMacroOptions.value);
const dropdownPopoverShown = ref(false);
const isModalOpen = ref(false);
const nameBuilder = ref<NameMacro[]>([]);
const fieldSeparator = ref('__');
const itemSeparator = ref('::');

const staticFields: MacroOptions[] = [
  {
    name: 'Text input',
    value: 'Your Text',
    description: 'Text input',
    nestedMacros: [],
    type: MacroType.TextValue,
    valueType: MacroType.TextValue,
  },
];

const macroOptions = computed(() => {
  const convertMacroToOption = (macro: MacroOptions): DropdownOption => ({
    ...macro,
    label: macro.name || macro.value,
    description: macro.description,
    id: uid(),
    type: macro.type,
    options: macro.nestedMacros ? macro.nestedMacros.map((m) => convertMacroToOption(m)) : [],
  });

  const values = [...props.macros, ...staticFields].map((m) => convertMacroToOption(m));
  return values;
});

const macroErrors = computed(() =>
  nameBuilder.value.some((macro) => macro.type === MacroType.TextValue && !macro.value)
);

function getValueForMacro(macro: NameMacro) {
  return macro.type === MacroType.TextValue ? macro.value : macro.name;
}

function editMacro(macro: NameMacro, value: string) {
  const index = nameBuilder.value.findIndex((m) => m.id === macro.id);
  if (index !== -1) nameBuilder.value[index].value = value;
}

function addMacro(option: DropdownOption) {
  const macro = {
    ...option,
    id: uid(),
    macro: option.id,
    type: option.type,
    name: option.label,
  };
  dropdownPopoverShown.value = false;
  nameBuilder.value.push(macro as unknown as NameMacro);
}

function removeMacro(macro: NameMacro) {
  const index = nameBuilder.value.findIndex((m) => m.id === macro.id);
  if (index !== -1) nameBuilder.value.splice(index, 1);
}

function onModalOpen() {
  nameBuilder.value =
    props.value?.macros?.map((macro) => ({
      id: uid(),
      name: macro.value,
      macro: macro.value,
      ...macro,
    })) || [];
  fieldSeparator.value = props.value?.fieldSeparator || '__';
  itemSeparator.value = props.value?.itemSeparator || '::';
  isModalOpen.value = true;
}

function onModalClose() {
  nameBuilder.value = [];
  isModalOpen.value = false;
}

function onModalSave() {
  emits('onSave', {
    macros: nameBuilder.value,
    fieldSeparator: fieldSeparator.value,
    itemSeparator: itemSeparator.value,
  });
  onModalClose();
}

expose({ onModalOpen });

return { __sfc: true,emits, props, macroError, fieldSeparatorError, itemSeparatorError, dropdownPopoverShown, isModalOpen, nameBuilder, fieldSeparator, itemSeparator, staticFields, macroOptions, macroErrors, getValueForMacro, editMacro, addMacro, removeMacro, onModalOpen, onModalClose, onModalSave, CcCardItem, CcDropdown, CcError, CcIcon, CardLayer, MacroType }
}

})